export class DocumentoHel {
  id: string;
  nombre: string;
  archivo: string;
  archivoName: string;
  fechaCreacion: any;
  fechaEdicion: any;
  typeFile: string;
}
